import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import {
  getAuth,
  onAuthStateChanged,
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { addVideoToWatchList, fetchWatchList, removeVideoFromWatchList } from './watchlist.services';

const isBrowser = typeof window !== 'undefined';

const secondaryFirebaseConfig = {
  apiKey: process.env.GATSBY_MEMBERSHIP_FIREBASE_API_KEY,
  authDomain: process.env.GATSBY_MEMBERSHIP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.GATSBY_MEMBERSHIP_FIREBASE_DATABASE_URL,
  projectId: process.env.GATSBY_MEMBERSHIP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.GATSBY_MEMBERSHIP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.GATSBY_MEMBERSHIP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.GATSBY_MEMBERSHIP_FIREBASE_APP_ID,
  measurementId: process.env.GATSBY_MEMBERSHIP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(secondaryFirebaseConfig, 'secondary');
const auth = getAuth(app);
const functions = getFunctions(app);
const db = getFirestore(app);

let appCheck;

if (isBrowser && process.env.GATSBY_SKIP_APPCHECK === 'false') {
  if (process.env.NODE_ENV === 'development' || process.env.SITE_URL?.includes('localhost')) {
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.APP_CHECK_DEBUG_TOKEN_FROM_CI;
  }
  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(process.env.GATSBY_FIREBASE_RECAPTCHA_SITE_KEY!),
    isTokenAutoRefreshEnabled: true,
  });
}

export {
  addVideoToWatchList,
  appCheck,
  auth,
  db,
  fetchWatchList,
  functions,
  removeVideoFromWatchList,
  onAuthStateChanged,
};
